import ApiService from '../../../core/services/ApiService';

export interface AuditLogField {
  field: string;
  previousValue: string | null;
  newValue: string | null;
}

export interface AuditLogEntry {
  id: string;
  timestamp: string;
  userName: string;
  userRole: string;
  module: string;
  action: string;
  actionClass: string;
  target: string;
  fields: AuditLogField[];
  isExpanded: boolean;
}

export interface AuditLogParams {
  module?: string;
  userId?: string;
  from?: string;
  to?: string;
}

class AuditLogService extends ApiService {
  async getLogs(params: AuditLogParams): Promise<AuditLogEntry[]> {
    const qs = new URLSearchParams(
      Object.entries(params).filter(([, v]) => v != null) as [string, string][],
    ).toString();
    return this.makeRequest<AuditLogEntry[]>(
      `/api/audit-log?${qs}`,
      { extractData: true },
    );
  }
}

export const auditLogService = new AuditLogService();
